module.exports = __webpack_public_path__ + "static/media/impact4.43348926.ogg";